import React from 'react';
import { connect, history } from 'umi';

import { isEmpty } from 'lodash';
import { Text, Button, Divider } from '@digitalc/dxp-ui';
import { onHistoryPush, getThemeImgByKey } from '@/utils/utils';
import useGCPI18n from '@/hooks/useGCPI18n';
import convertSuccess from '@/assets/images/point/convertSuccess.png';
import styles from './index.less';

const SuccessPage = props => {
  const { dxpToken } = props;

  const {
    serviceNumber,
    goods,
    pointValue,
    pointType,
    needDetail = true,
    renderList,
    btnText,
    backUrl,
  } = history?.location?.state || {};
  const GCPI18n = useGCPI18n();

  const renderDefaultList = () => (
    <>
      <div className={styles.contentItem}>
        <Text
          breakpoint="Mobile"
          size="ContentC14Regular"
          style={{ color: dxpToken.colorTextItemtitle }}
        >
          {GCPI18n('lb_redeem_service_number')}
        </Text>
        <Text
          breakpoint="Mobile"
          size="ContentC14Regular"
          style={{ color: dxpToken.colorTextNeutral }}
        >
          {serviceNumber || '-'}
        </Text>
      </div>

      <div className={styles.contentItem}>
        <Text
          breakpoint="Mobile"
          size="ContentC14Regular"
          style={{ color: dxpToken.colorTextItemtitle }}
        >
          {GCPI18n('lb_redeem_goods')}
        </Text>
        <Text
          breakpoint="Mobile"
          size="ContentC14Regular"
          style={{ color: dxpToken.colorTextNeutral }}
        >
          {goods || '-'}
        </Text>
      </div>

      <div className={styles.contentItem}>
        <Text
          breakpoint="Mobile"
          size="ContentC14Regular"
          style={{ color: dxpToken.colorTextItemtitle }}
        >
          {GCPI18n('lb_redeem_point_type')}
        </Text>
        <Text
          breakpoint="Mobile"
          size="ContentC14Regular"
          style={{ color: dxpToken.colorTextNeutral }}
        >
          {pointType || '-'}
        </Text>
      </div>

      <div className={styles.contentItem}>
        <Text
          breakpoint="Mobile"
          size="ContentC14Regular"
          style={{ color: dxpToken.colorTextItemtitle }}
        >
          {GCPI18n('lb_point')}
        </Text>
        <Text
          breakpoint="Mobile"
          size="ContentC14Regular"
          style={{ color: dxpToken.colorTextNeutral }}
        >
          {pointValue || '-'}
        </Text>
      </div>
    </>
  );

  const renderContent = () => {
    if (!isEmpty(renderList)) {
      return (
        <>
          {renderList.map(it => (
            <div className={`${styles.contentItem} ${styles.voucherItem}`}>
              <Text
                breakpoint="Mobile"
                size="ContentC14Regular"
                className={styles.label}
                style={{ color: dxpToken.colorTextItemtitle }}
              >
                {it.label}
              </Text>
              <Text
                breakpoint="Mobile"
                size="ContentC14Regular"
                className={styles.value}
                style={{ color: dxpToken.colorTextNeutral }}
              >
                {it.value || '-'}
              </Text>
            </div>
          ))}
        </>
      );
    }
    return renderDefaultList();
  };

  return (
    <div className={styles.successPage}>
      <div className={styles.imgWrap}>
        <img src={getThemeImgByKey('genericSuccess') || convertSuccess} alt="" />
      </div>

      <Text breakpoint="Mobile" size="TitleT23Bold" style={{ color: dxpToken.colorTextNeutral }}>
        {GCPI18n('lb_redeem_successfully')}
      </Text>

      <Divider style={{ margin: '0.16rem 0rem' }} />
      {needDetail && (
        <Text
          breakpoint="Mobile"
          size="ContentC14Bold"
          style={{ marginBottom: '0.16rem', color: dxpToken.colorTextNeutral }}
        >
          {GCPI18n('lb_redeem_details')}
        </Text>
      )}
      {renderContent()}

      <Divider />

      <div className={styles.footer}>
        <Button
          block
          type="primary"
          onClick={() => {
            onHistoryPush(backUrl || '/pointshop/pointsH5');
          }}
        >
          {btnText ||
            GCPI18n({
              id: 'lb_back_to_point_mall',
            })}
        </Button>
      </div>
    </div>
  );
};

export default connect(({ index }) => ({
  dxpToken: index.dxpToken,
}))(SuccessPage);
